(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
(function(){
  var translations = {
    'zh-TW': '<h5>✔️ 韓國美容與健康的創新技術  <br/>✔️ 科研驅動的高端配方  <br/>✔️ 為現代日常護膚而設計</h5>',
    'ko': '<h5>✔️ 한국 뷰티 & 웰니스의 혁신  <br/>✔️ 과학이 이끌어내는 프리미엄 포뮬레이션  <br/>✔️ 현대인의 일상 케어를 위한 디자인</h5>'
  };
  function swapCheckmarks() {
    var locale = window.Shopify && window.Shopify.locale ? window.Shopify.locale : 'en';
    var t = translations[locale];
    if (!t) return;
    var el = document.querySelector('[class*="text_Jk46BX"] rte-formatter, [class*="text_Jk46BX"] .rte');
    if (!el) {
      el = document.querySelector('[class*="text_Jk46BX"]');
    }
    if (el) { el.innerHTML = t; }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', swapCheckmarks);
  } else {
    swapCheckmarks();
  }
  // Apply Korean class for brand statement letter-spacing
  (function(){
    var loc=window.Shopify&&window.Shopify.locale?window.Shopify.locale:'zh-TW';
    if(loc==='ko'){
      document.querySelectorAll('.skinnova-brand-statement').forEach(function(el){el.classList.add('lang-ko');});
    }
  })();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
(function(){
  var ann={'zh-TW':'✶ 韓國專業皮膚科研面膜 · 5盒套装：立享42%折扣 · 免費送貨 ✶','ko':'✶ 한국 피부과학 연구 · 5박스 세트: 40% 할인 · 무료 배송 ✶','en':'✶ Korean Dermatological Research · 5-Box Bundle: 40% OFF · Free Shipping ✶'};
  var col={'zh-TW':'深層修護系列','ko':'피부 복구 시리즈','en':'Skin Repair Series'};
  function swap(){
    var loc=(window.Shopify&&window.Shopify.locale)?window.Shopify.locale:'zh-TW';
    var a=ann[loc]||ann['en'],c=col[loc]||col['en'];
    var ae=document.querySelector('.announcement-bar__message');
    if(ae&&loc!=='zh-TW')ae.textContent=a;
    var ce=document.querySelector('[class*="product_list_text"]');
    if(ce&&loc!=='zh-TW'){var p=ce.querySelector('p')||ce;p.textContent=c;}
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',swap);}else{swap();}
})();


(function() {
  function getRange() {
    var h = new Date().getHours();
    if (h >= 8 && h < 12) return [4, 9];
    if (h >= 12 && h < 18) return [7, 17];
    if (h >= 18 && h < 24) return [14, 27];
    return [1, 5];
  }
  function rand(min, max) { return Math.floor(Math.random() * (max - min + 1)) + min; }
  function updateHeaderCount() {
    var el = document.getElementById('header-visitor-count');
    if (!el) return;
    var r = getRange();
    el.style.transition = 'opacity 0.3s';
    el.style.opacity = '0';
    setTimeout(function() {
      el.textContent = rand(r[0], r[1]);
      var mEl = document.getElementById('header-visitor-count-mobile');
      if (mEl) { mEl.textContent = el.textContent; }
      el.style.opacity = '1';
    }, 300);
  }
  document.addEventListener('DOMContentLoaded', function() {
    updateHeaderCount();
    setInterval(updateHeaderCount, 15000);
  });
})();

(function() {
  function getRange() {
    var h = new Date().getHours();
    if (h >= 8 && h < 12) return [4, 9];
    if (h >= 12 && h < 18) return [7, 17];
    if (h >= 18 && h < 24) return [14, 27];
    return [1, 5];
  }
  function rand(a,b) { return Math.floor(Math.random()*(b-a+1))+a; }
  function inject() {
    var desktop = document.querySelector('.dropdown-localization');
    if (desktop && !document.getElementById('hvc')) {
      var d = document.createElement('div');
      d.id='hvc-desktop-wrapper'; d.style.cssText = 'display:flex;align-items:center;gap:6px;font-size:0.8rem;opacity:0.85;white-space:nowrap;padding:0 4px;';
      d.innerHTML = '<span><span style="display:inline-block;width:7px;height:7px;border-radius:50%;background:#22c55e;vertical-align:middle;flex-shrink:0;"></span></span><span id="hvc" style="font-weight:700">--</span><span>online</span>';
      desktop.insertAdjacentElement('afterend', d);
    }
    var mobile = document.querySelector('.mobile-lang-bar');
    if (mobile && !document.getElementById('hvc-m')) {
      var m = document.createElement('div');
      m.style.cssText = 'display:flex;align-items:center;gap:5px;font-size:0.78rem;opacity:0.85;margin-left:12px;white-space:nowrap;';
      m.innerHTML = '<span><span style="display:inline-block;width:7px;height:7px;border-radius:50%;background:#22c55e;vertical-align:middle;flex-shrink:0;"></span></span><span id="hvc-m" style="font-weight:700">--</span><span>online</span>';
      mobile.appendChild(m);
    }
    function update() {
      var r=getRange(),n=rand(r[0],r[1]),e=document.getElementById('hvc'),m=document.getElementById('hvc-m');
      if(e){e.style.transition='opacity 0.3s';e.style.opacity='0';setTimeout(function(){e.textContent=n;e.style.opacity='1';if(m)m.textContent=n;},300);}
    }
    update(); setInterval(update,15000);
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',inject);}else{inject();}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
